/* eslint-disable */

import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { RxCross2 } from "react-icons/rx";
import Swal from "sweetalert2";

import { FaArrowLeft, FaPray } from "react-icons/fa";
import BASE_API_URL from "../../../../api/api";
import apiInstance from "../../../../Utils/api";
const Top = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 20px 30px;
`;

const Center = styled.div`
  flex: 1;
  display: inline;
  text-align: center;
`;

const Button = styled.button`
  background: rgb(0, 7, 51);
  color: white;
  justify-content: center;
  padding: 5px 30px;
  border: none;
  border-radius: 10px;
  margin-top: 20px;
`;

const Title = styled.h5`
  font-weight: bold;
  margin-top: 10px;
`;
const Div = styled.div``;
const Label = styled.label``;
const Input = styled.input`
  width: 100%;
`;
const Span = styled.span`
  color: red;
`;
const Textarea = styled.textarea``;

const Select = styled.select`
  padding: 5px 7px;
  border-radius: 5px;
`;
const Option = styled.option``;

const Table = styled.table``;
const Thead = styled.thead``;
const Tbody = styled.tbody``;
const Tr = styled.tr`
  text-align: center;
`;
const Th = styled.th`
  font-size: 15px;
`;
const Td = styled.td`
  font-size: 14px;
`;

const Create = () => {
  const token = localStorage.getItem("token");
  const url = BASE_API_URL;
  const api = apiInstance;
  const Name = localStorage.getItem("Name");
  const [doctors, setDoctors] = useState([]);
  const [stockList, setStockList] = useState([]);
  const [stockProList, setStockProList] = useState([]);
  const [stockGenList, setStockGenList] = useState([]);
  const [stockAccList, setStockAccList] = useState([]);
  const [therapists, setTherapists] = useState([]);
  const [procedures, setProcedures] = useState([]);
  const [machines, setMachines] = useState([]);
  const [accessories, setAccessories] = useState([]);
  const [medicineList, setMedicineList] = useState([]);
  const [items, setItems] = useState([]);
  const [isItem, setIsItem] = useState(false);
  const [id, setId] = useState("");
  const [accitems, setAccItems] = useState([]);
  const [isAccItem, setIsAccItem] = useState(false);
  const [accid, setAccId] = useState("");
  const [macitems, setMacItems] = useState([]);
  const [isMacItem, setIsMacItem] = useState(false);
  const [medItems, setMedItems] = useState([]);
  const [isMedItem, setIsMedItem] = useState(false);
  const [qty, setQty] = useState("");

  const [branchID, setBranchID] = useState("");
  const [upBranchID, setUpBranchID] = useState("");
  const [upBranchName, setUpBranchName] = useState("");
  const [branchLists, setBranchLists] = useState([]);

  const [date, setDate] = useState("");
  const [stockReqData, setStockReqData] = useState([]);
  const [reqNo, setReqNo] = useState("");
  const [reqBy, setReqBy] = useState("");

  const [upProData, setUpProData] = useState([]);
  const [upMedData, setUpMedData] = useState([]);
  const [upProAcc, setUpProAcc] = useState([]);
  const [upGen, setUpGen] = useState([]);
  const [isGenItem, setIsGenItem] = useState(false);
  //Pro Medicine
  const [tableProData, setTableProData] = useState([]);
  const [selectOption, setSelectOption] = useState({
    id: "",
    name: "",
  });

  //Medicine
  const [tableMedData, setTableMedData] = useState([]);
  const [selectMedOption, setSelectMedOption] = useState({
    id: "",
    name: "",
  });

  //Medicine
  const [tableProAccData, setTableProAccData] = useState([]);
  const [selectProAccOption, setSelectProAccOption] = useState({
    id: "",
    name: "",
  });
  const [tableGenData, setTableGenData] = useState([]);
  const [selectGenOption, setSelectGenOption] = useState({
    id: "",
    name: "",
  });

  const PrintId = useLocation().pathname.split("/")[2];
  const print = () => {
    let printContents = document.getElementById("print").innerHTML;
    let originalContents = document.body.innerHTML;
    document.body.innerHTML = printContents;
    window.print();
    document.body.innerHTML = originalContents;
    window.location.reload();
  };

  useEffect(() => {
    const getMedicine = async () => {
      const res = await api.get("medicine-items");
      setMedicineList(res.data.list);
    };

    const getProcedures = async () => {
      const res = await api.get("procedure-items");
      setProcedures(res.data.list);
    };
    const getAccessories = async () => {
      const res = await api.get("accessory-items");
      // console.log(res.data.list)
      setAccessories(res.data.list);
    };

    const getBranch = async () => {
      const res = await api.get("branches");
      // console.log(res.data.list)
      setBranchID(res.data.list[0]._id);
      setBranchLists(res.data.list);
    };

    const getStockTranList = async () => {
      try {
        const res = await api.get("stock-transfer/" + PrintId);

        // console.log(res.data.data[0], 'ST')
        setStockReqData(res.data.data[0]);
        setReqNo(res.data.data[0].requestNo);
        setReqBy(res.data.data[0].requestedBy);
        setUpBranchID(res.data.data[0].relatedBranch._id);
        setUpBranchName(res.data.data[0].relatedBranch.name);
        setDate(res.data.data[0].date);
        //NOTE For Meducine
        if (
          res.data.data[0].medicineLists !== null &&
          res.data.data[0].medicineLists.length > 0
        ) {
          const newData = res.data.data[0].medicineLists.map((data, index) => {
            return {
              id: index,
              name: data.item_id ? data.item_id.medicineItemName : "",
              item_id: data.item_id,
              stockQty: data.stockQty,
              requestedQty: data.requestedQty,
              transferQty: data.transferQty,
            };
          });
          setUpMedData(newData);
          setIsMedItem(true);
        }
        //NOTE For Procedure Medicine
        if (
          res.data.data[0].procedureMedicine !== null &&
          res.data.data[0].procedureMedicine.length > 0
        ) {
          const newData = res.data.data[0].procedureMedicine.map(
            (data, index) => {
              return {
                id: index,
                name: data.item_id ? data.item_id.procedureItemName : "",
                item_id: data.item_id,
                stockQty: data.stockQty,
                requestedQty: data.requestedQty,
                transferQty: data.transferQty,
              };
            },
          );
          setUpProData(newData);
          setIsItem(true);
        }
        //NOTE For Procedure Accessory
        if (
          res.data.data[0].procedureAccessory !== null &&
          res.data.data[0].procedureAccessory.length > 0
        ) {
          const newData = res.data.data[0].procedureAccessory.map(
            (data, index) => {
              return {
                id: index,
                name: data.item_id ? data.item_id.accessoryItemName : "",
                item_id: data.item_id,
                stockQty: data.stockQty,
                requestedQty: data.requestedQty,
                transferQty: data.transferQty,
              };
            },
          );
          setUpProAcc(newData);
          // console.log(newData, 'Pro Acc')
          setIsAccItem(true);
        }
        if (
          res.data.data[0].generalItems !== null &&
          res.data.data[0].generalItems?.length > 0
        ) {
          console.log(res.data.data[0], "geennn");
          const newData = res.data.data[0].generalItems.map((data, index) => {
            return {
              id: index,
              name: data.item_id ? data.item_id.generalItemName : "",
              item_id: data.item_id,
              stockQty: data.item_id.currentQuantity,
              requestedQty: data.requestedQty,
              purchasePrice: data.purchasePrice,
              totalPrice: data.totalPrice,
              transferQty: data.transferQty,
            };
          });
          setUpGen(newData);

          console.log(newData, "Gen");
          setIsGenItem(true);
        }
      } catch (err) {
        alert(err.message);
      }
    };
    const getStocks = async () => {
      const res = await api.get("stocks");
      // setMedicineList(res.data.list)
      console.log(
        res.data.data.filter(
          (el) =>
            el.relatedBranch?._id === upBranchID &&
            el.relatedMedicineItems?._id,
        ),
        "stock",
      );

      setStockList(
        res.data.data.filter(
          (el) =>
            el.relatedBranch?._id === upBranchID &&
            el.relatedMedicineItems?._id,
        ),
      );
      setStockProList(
        res.data.data.filter(
          (el) =>
            el.relatedBranch?._id === upBranchID &&
            el.relatedProcedureItems?._id,
        ),
      );
      setStockAccList(
        res.data.data.filter(
          (el) =>
            el.relatedBranch?._id === upBranchID &&
            el.relatedAccessoryItems?._id,
        ),
      );
      setStockGenList(
        res.data.data.filter(
          (el) =>
            el.relatedBranch?._id === upBranchID && el.relatedGeneralItems?._id,
        ),
      );
    };
    getStocks();
    getMedicine();

    getStockTranList();
    getProcedures();
    getAccessories();
    getBranch();
  }, [stockList]);

  return (
    <>

        <div className="content-wrapper">
          <div className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-12">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/stock-tran">
                        <i>
                          <FaArrowLeft />
                        </i>
                      </Link>
                    </li>
                    <li className="breadcrumb-item active">Stock Issue</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          <section className="content">
            <div className="container-fluid">
              <div className="card-body row border border-dark" id="print">
                <div className="text-center fs-1">Stock Issue</div>
                <div className="offset-1 col-10 py-5">
                  <div className="row">
                    <div className="col-6 form-group ">
                      <div className="row">
                        <div className="col-6 fs-4">
                          <Label>
                            Date<Span>*</Span>
                          </Label>
                        </div>
                        <div className="col-6">
                          <div className="fs-4">
                            {date ? date.split("T")[0] : ""}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div class="form-group">
                        <div className="row">
                          <div className="col-6 fs-4">
                            <label for="name">Branches :</label>
                          </div>
                          <div className="col-6 fs-4">{upBranchName}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-6 form-group ">
                      <div className="row">
                        <div className="col-6 fs-4">
                          <Label>
                            Request No:<Span>*</Span>
                          </Label>
                        </div>
                        <div className="col-6">
                          <div className="fs-4">{stockReqData?.transferNo}</div>
                        </div>
                      </div>
                    </div>
                    <div className="col-6 form-group">
                      <div className="row">
                        <div className="col-6 fs-4">
                          <Label>
                            Request By:<Span>*</Span>
                          </Label>
                        </div>
                        <div className="col-6">
                          <div className="fs-4">{stockReqData?.transferBy}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-6 form-group ">
                      <div className="row">
                        <div className="col-6 fs-4">
                          <Label>
                            Issue No:<Span>*</Span>
                          </Label>
                        </div>
                        <div className="col-6">
                          <div className="fs-4">{reqNo}</div>
                        </div>
                      </div>
                    </div>
                    <div className="col-6 form-group">
                      <div className="row">
                        <div className="col-6 fs-4">
                          <Label>
                            Issue By:<Span>*</Span>
                          </Label>
                        </div>
                        <div className="col-6">
                          <div className="fs-4">{reqBy}</div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-6 form-group mt-3 fs-4">
                      <Label>Medicine</Label>
                    </div>
                  </div>

                  <div className="col-12 mt-3">
                    <Table className="table table-striped ">
                      <Thead>
                        <Tr>
                          {/* <Th>No.</Th> */}
                          <Th className="fs-5">Item Name</Th>

                          <Th className="fs-5">
                            Stock Quantity Branch {upBranchName}
                          </Th>

                          <Th className="fs-5">Requested Qty</Th>
                          <Th className="fs-5">Transfer Qty</Th>
                        </Tr>
                      </Thead>
                      {isMedItem && (
                        <Tbody>
                          {upMedData &&
                            upMedData.map((item, index) => (
                              <Tr>
                                {/* <Td>{++index}</Td> */}

                                <Td className="fs-5">{item.name}</Td>
                                <Td className="fs-5">
                                  {stockList
                                    .filter(
                                      (i) =>
                                        i.relatedMedicineItems?._id ===
                                        item?.item_id?._id,
                                    )[0]
                                    ?.currentQty?.toFixed(2)}
                                </Td>
                                {/* <Td>{procedure.purchasePrice}</Td> */}
                                <Td className="fs-5">{item.requestedQty}</Td>
                                <Td className="fs-5">{item.transferQty}</Td>
                              </Tr>
                            ))}
                        </Tbody>
                      )}
                    </Table>
                  </div>

                  {/* NOTE Procedure Medicine */}
                  <div className="row">
                    <div className="col-6 form-group mt-3 fs-4">
                      <Label>Procedure Medicine</Label>
                    </div>
                  </div>

                  <div className="col-12 mt-4">
                    <Table className="table table-striped">
                      <Thead>
                        <Tr>
                          {/* <Th>No.</Th> */}
                          <Th className="fs-5">Item Name</Th>

                          <Th className="fs-5">
                            Stock Quantity Branch {upBranchName}
                          </Th>

                          <Th className="fs-5">Requested Qty</Th>
                          <Th className="fs-5">Transfer Qty</Th>
                        </Tr>
                      </Thead>
                      {isItem && (
                        <Tbody>
                          {upProData &&
                            upProData.map((item, index) => (
                              <Tr>
                                {/* <Td>{++index}</Td> */}

                                <Td className="fs-5">{item.name}</Td>
                                {/* <Td>
                                <input
                                  type='number'
                                  // defaultValue={procedure.qty}
                                  defaultValue={item.quantity}
                                  onChange={event =>
                                    handleProInputChange(
                                      event,
                                      item.id,
                                      'quantity'
                                    )
                                  }
                                  className='size-10'
                                />
                              </Td> */}
                                <Td className="fs-5">
                                  {stockProList
                                    .filter(
                                      (i) =>
                                        i.relatedProcedureItems?._id ===
                                        item?.item_id?._id,
                                    )[0]
                                    ?.currentQty?.toFixed(2)}
                                </Td>
                                <Td className="fs-5">{item.requestedQty}</Td>
                                <Td className="fs-5">{item.transferQty}</Td>

                                {/* <Td>{procedure.purchasePrice}</Td> */}
                              </Tr>
                            ))}
                        </Tbody>
                      )}
                    </Table>
                  </div>
                  {/* NOTE End Procedure Medicine */}

                  <div className="row">
                    <div className="col-6 form-group mt-3 fs-4">
                      <Label>Procedure Accessory</Label>
                    </div>
                  </div>
                  <div className="col-12 mt-3">
                    <Table className="table table-striped">
                      <Thead>
                        <Tr>
                          <Th className="fs-5">Item Name</Th>

                          <Th className="fs-5">
                            Stock Quantity Branch {upBranchName}{" "}
                          </Th>

                          <Th className="fs-5">Requested Qty</Th>
                          <Th className="fs-5">Transfer Qty</Th>
                        </Tr>
                      </Thead>
                      {isAccItem && (
                        <Tbody>
                          {upProAcc &&
                            upProAcc.map((item, index) => (
                              <Tr>
                                {/* <Td>{++index}</Td> */}

                                <Td className="fs-5">{item.name}</Td>
                                {/* <Td>
                                <input
                                  type='number'
                                  // defaultValue={procedure.qty}
                                  defaultValue={item.quantity}
                                  onChange={event =>
                                    handleProAccInputChange(
                                      event,
                                      item.id,
                                      'quantity'
                                    )
                                  }
                                  className='size-10'
                                />
                              </Td> */}
                                <Td className="fs-5">
                                  {stockAccList
                                    .filter(
                                      (i) =>
                                        i.relatedAccessoryItems?._id ===
                                        item?.item_id?._id,
                                    )[0]
                                    ?.currentQty?.toFixed(2)}
                                </Td>
                                <Td className="fs-5">{item.requestedQty}</Td>
                                <Td className="fs-5">{item.transferQty}</Td>
                              </Tr>
                            ))}
                        </Tbody>
                      )}
                    </Table>
                  </div>
                  {/* NOTE End Procedure Accessory */}

                  <div className="row">
                    <h4 className="text-decoration-underline">General Items</h4>
                  </div>
                  <div className="col-12 mt-3">
                    <Table className="table">
                      <Thead>
                        <Tr>
                          <Th className="fs-5">Item Name</Th>

                          <Th className="fs-5">
                            Stock Quantity Branch {upBranchName}
                          </Th>

                          <Th className="fs-5">Requested Quantity</Th>
                          <Th className="fs-5">Transfer Qty</Th>
                        </Tr>
                      </Thead>
                      {isGenItem && (
                        <Tbody>
                          {upGen &&
                            upGen.map((item, index) => (
                              <Tr>
                                <Td className="fs-5">{item.name}</Td>

                                <Td className="fs-5">
                                  {stockGenList
                                    .filter(
                                      (i) =>
                                        i.relatedGeneralItems?._id ===
                                        item?.item_id?._id,
                                    )[0]
                                    ?.currentQty?.toFixed(2)}
                                </Td>
                                <Td className="fs-5">{item.requestedQty}</Td>

                                <Td className="fs-5">{item?.transferQty}</Td>
                                <Td className="fs-5">{item?.totalPrice}</Td>
                                <Td className="fs-5">{item.item_id?.unit}</Td>

                                {/* <Td>
                                  <RxCross2
                                    onClick={() => removeProAcc(item.item_id)}
                                  />
                                </Td> */}
                              </Tr>
                            ))}

                          {tableGenData.map((item, index) => (
                            <Tr>
                              {/* <Td>{++index}</Td> */}
                              <Td>{item.name}</Td>
                              {/* <Td>
                                <input
                                  type='number'
                                  // defaultValue={procedure.qty}
                                  defaultValue={item.quantity}
                                  onChange={event =>
                                    handleProAccInputChange(
                                      event,
                                      item.id,
                                      'quantity'
                                    )
                                  }
                                  className='size-10'
                                />
                              </Td> */}
                              <Td>3</Td>
                              <Td>
                                <input
                                  type="number"
                                  style={{ borderRadius: "15px" }}
                                  defaultValue={item.perUsageQTY}
                                  onChange={(event) =>
                                    handleGenInputChange(
                                      event,
                                      item.id,
                                      "requestedQty",
                                    )
                                  }
                                  className="size-10"
                                />
                              </Td>

                              <Td>
                                <input
                                  type="number"
                                  defaultValue={item.transferQty}
                                  style={{ borderRadius: "10px" }}
                                  className="text-center"
                                  onChange={(event) =>
                                    handleGenInputChange(
                                      event,
                                      item.id,
                                      "transferQty",
                                    )
                                  }
                                />
                              </Td>
                              <Td>
                                <RxCross2
                                  onClick={() => removeGen(item.item_id)}
                                />
                              </Td>
                            </Tr>
                          ))}
                        </Tbody>
                      )}
                    </Table>
                  </div>
                  <div
                    className="row py-3"
                    style={{
                      fontSize: "16px",
                      marginTop: "20em",
                    }}
                    id="printtop
"
                  >
                    <div className="offset-1 col-2 ">
                      <b className="ml-4">Issue By</b>

                      <div
                        className="mt-5 "
                        style={{ borderBottom: "1px solid" }}
                      ></div>
                    </div>
                    <div className="col-2 ">
                      <b className="ml-4">Checked By</b>

                      <div
                        className="mt-5 "
                        style={{ borderBottom: "1px solid" }}
                      ></div>
                    </div>
                    <div className=" col-2">
                      <b className="ml-4">Received By</b>
                      <div
                        className="mt-5 "
                        style={{ borderBottom: "1px solid" }}
                      ></div>
                    </div>
                    <div className="col-2">
                      <b className="ml-4">Checked By</b>

                      <div
                        className="mt-5 "
                        style={{ borderBottom: "1px solid" }}
                      ></div>
                    </div>
                    <div className="col-2">
                      <b className="ml-4">Approved By</b>

                      <div
                        className="mt-5"
                        style={{
                          borderBottom: "1px solid",
                        }}
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
              <Top>
                <div className="row mb-3" style={{ marginLeft: "550px" }}>
                  <div className="col-4">
                    <button
                      onClick={print}
                      style={{
                        borderRadius: "10px",
                        marginTop: "1.3em",
                        fontSize: "15px",
                        backgroundColor: "pink",
                      }}
                      className="btn btn-sm mb-2"
                    >
                      Print
                    </button>
                  </div>
                </div>
              </Top>
            </div>
          </section>
        </div>

    </>
  );
};

export default Create;
